export default "__VITE_ASSET__DchqRV4o__"